import { formatRevenueDisplay } from '../../utils/revenue-display';
import { ReportPeriod } from '../../contracts/reporting-policy.generated';

export const REPORT_PERIOD_LABELS: Partial<Record<ReportPeriod, string>> = {
  today: 'Today',
  yesterday: 'Yesterday',
  last7: 'Last 7 days',
  last30: 'Last 30 days',
  last90: 'Last 90 days',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  thisYear: 'This year',
  custom: 'Custom dates',
  all: 'All time',
};

/** Complete report admission is shared by both explicit cohort adapters and CSV. */
export function assertCompleteMetricsReport(payload: any, rowsKey: string, reportId: string): void {
  const rows = payload?.[rowsKey],
    report = payload?.report;
  if (
    !Array.isArray(rows) ||
    payload?.reporting?.complete !== true ||
    report?.policyVersion !== 1 ||
    report?.reportId !== reportId ||
    !report?.executionId ||
    !Number.isSafeInteger(report?.matchedRows) ||
    report.matchedRows !== report.returnedRows ||
    report.returnedRows !== rows.length ||
    new Set(rows.map((row: any) => row.key || row.id)).size !== rows.length
  ) {
    throw new Error('Complete reporting snapshot unavailable. Refresh after deployment.');
  }
}
export function metricRowsForGroup(rows: any[], group?: string): any[] {
  return group ? rows.filter((row) => row.summaryGroup === group) : rows;
}
export function exportMetricsRows(
  payload: any,
  domain: { rowsKey: string; reportId: string; meaning: string; fields: Record<string, string> }
) {
  assertCompleteMetricsReport(payload, domain.rowsKey, domain.reportId);
  return payload[domain.rowsKey].map((row: any) => {
    const fields = Object.fromEntries(
      Object.entries(domain.fields).map(([name, source]) => [name, row[source] ?? null])
    );
    return {
      ...fields,
      amountDisplay: formatRevenueDisplay(fields['amount'] as number | null, fields['currency'] as string, undefined, {
        emptyLabel: 'Amount unavailable',
      }),
      paymentMeaning: domain.meaning,
      reportExecutionId: payload.report.executionId,
      effectivePlan: JSON.stringify(payload.report.effectivePlan || {}),
      policyVersion: payload.report.policyVersion,
      coverage: payload.report.coverage,
      sourceWatermark: payload.report.sourceWatermark,
    };
  });
}
